module.exports = __webpack_public_path__ + "media/images/faq/img_top-97757406d846c26cafdaff88ea6a54f1.jpg";